export default {
  path: '/my-card-record',
  meta: {
    title: '核销记录',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/my-card-record`),
}



// WEBPACK FOOTER //
// ./src/views/cardRecord/router.js